/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PurchaseGiftconProductDto } from '../models/PurchaseGiftconProductDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class GiftconOrdersService {
  /**
   * 기프티콘 구매
   * @returns any
   * @throws ApiError
   */
  public static giftconOrderControllerPurchaseGiftconProduct({
    requestBody,
  }: {
    requestBody: PurchaseGiftconProductDto;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/giftcon-orders',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
